import {RequestFailedError} from '../../common/errors';

type CustomizationOrderFormResponse = {
    success: boolean;
    validation_errors: string;
    redirect: string;
};

export default class CustomizationOrderSubmitMapper {
    async submitCustomizationOrderForm(orderFormAction: string, orderFormData: FormData): Promise<CustomizationOrderFormResponse | RequestFailedError> {
        const request = await fetch(orderFormAction + '/', {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            method: 'post',
            cache: 'no-cache',
            credentials: 'same-origin',
            body: orderFormData,
        });

        if (request.status !== 200) {
            return new RequestFailedError();
        }

        return request.json();
    }
}
